// DS: i12.5
import React from 'react';
import IconWrap, {Props} from '../../IconWrap';

const StudioGift: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="currentColor"
          d="M5 7C5 7.72857 5.19479 8.41165 5.53513 9L2.5 9C1.94772 9 1.5 9.44772 1.5 10C1.5 10.5523 1.94772 11 2.5 11L21.5 11C22.0523 11 22.5 10.5523 22.5 10C22.5 9.44771 22.0523 9 21.5 9L18.4649 9C18.8052 8.41165 19 7.72857 19 7C19 4.79086 17.2091 3 15 3C13.8053 3 12.7329 3.52376 12 4.35418C11.2671 3.52376 10.1947 3 9 3C6.79086 3 5 4.79086 5 7ZM13 9L15.0023 9C16.1058 8.99878 17 8.10381 17 7C17 5.89543 16.1046 5 15 5C13.8954 5 13 5.89543 13 7V9ZM11 7V9L8.99837 9C7.89455 8.99912 7 8.10402 7 7C7 5.89543 7.89543 5 9 5C10.1046 5 11 5.89543 11 7Z"
        />
        <path
          fill="currentColor"
          d="M5.5 13C5.5 12.4477 5.05228 12 4.5 12C3.94772 12 3.5 12.4477 3.5 13V20C3.5 20.5523 3.94772 21 4.5 21H11.9871L12 21.0001L12.0129 21H19.5C20.0523 21 20.5 20.5523 20.5 20V13C20.5 12.4477 20.0523 12 19.5 12C18.9477 12 18.5 12.4477 18.5 13V19H13V13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13V19H5.5V13Z"
        />
      </svg>
    </IconWrap>
  );
};
StudioGift.displayName = 'StudioGift';

export default StudioGift;
